// import { BrowserClient, Hub } from '@sentry/browser';
import * as Sentry from '@sentry/react';
import Environment from './Environment';

const beforeSendHelper = (message, event) => {
  if (message) {
    if (
      message.includes('InvalidToken') ||
      message.startsWith('TypeError: cancelled')
    ) {
      return null;
    }
    if (
      message.includes('Oops!') ||
      message.includes('EMAIL_EXISTS') ||
      message.includes('STRIPE_ERROR')
    ) {
      const sentryEvent = event;
      sentryEvent.level = 'info';
      return sentryEvent;
    }
  }
  return event;
};

const initTime = () => {
  if (Environment.getEnv !== 'DEVELOPMENT') {
    Sentry.init({
      dsn:
        'https://6e212757b0df491d92eb19888ad53575@o130078.ingest.sentry.io/287221',
      environment: Environment.getEnv,

      beforeSend(event, hint) {
        const { message } = hint.originalException;
        return beforeSendHelper(message, event);
      },
    });
  }
};

export default {
  initTime,
  beforeSendHelper,
};
